import styled from 'styled-components';

import {
  Form as SemanticForm,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const mobileLimit = (breakpoints) => `${breakpoints.sm - 1}px`;

export const Container = styled.div`
  padding: 70px 25%;
  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    padding: 20px;
  }
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    padding: 20px;
    padding-bottom: 35px;
  }
`;

export const Text = styled(TextLayoutComponent)``;

export const Title = styled(TextLayoutComponent.Title)``;

export const Header = styled.div`
  margin-top: 20px;
`;

export const Form = styled(SemanticForm)`
  &.ui.form {
    padding: 20px 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 40px;
`;

export const NextButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 125px;
  }
`;

export const BackButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    margin-right: 60px;
    width: 125px;
  }
`;

export const ContainerDate = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TextBold = styled(TextLayoutComponent)`
  font-weight: 500;
`;

export const ErrorMessage = styled(TextLayoutComponent)`
  color: ${({ theme }) => theme.color.error};
  font-weight: 500;
  padding-top: 10px;
`;
